import angular from 'angular';
import ServicesModule from '../../../services/services';
import ResourcesModule from '../../../resources/resources';
import template from './usersIndex.jade';
import * as UsersActions from '../../../actions/users-actions';
import * as GameDevelopersActions from '../../../actions/gameDevelopers-actions';
import ngRedux from 'ng-redux';

export class UsersIndexController {
  /* @ngInject */
  constructor($scope, $q, $window, $filter, UsersResource, GameDevelopersResource, ggTable, $ngRedux, currentUser, notify) {
    this.$window = $window;
    this.$q = $q;
    this.$ngRedux = $ngRedux;
    this.translateWith = $filter('translateWith');
    this.UsersResource = UsersResource;
    this.GameDevelopersResource = GameDevelopersResource;
    this.userNameFilterValue = '';
    this.currentUser = currentUser;
    this.notify = notify;

    if (currentUser.value.hasRole('OPERATION_MANAGER')) {
      this.roles = ['AGENCY', 'ADMIN_AGENCY', 'GD_ACCOUNT_MANAGER'];
    } else {
      this.roles = [
        'ADMIN',
        'GG_ACCOUNT_MANAGER',
        'APP_DEVELOPER',
        'GD_ACCOUNT_MANAGER',
        'AGENCY',
        'ADMIN_AGENCY',
        'SELLER_ONLY',
        'BUYER_ONLY',
        'OPERATION_MANAGER'
      ];
    }

    this.resourcesTable = new ggTable({count: 30});
    this.resourcesTable.filter()['roles'] = this.roles[0];
    this.resourcesTable.filter()['search'] = this.userNameFilterValue;
    this.resourcesTable.customFilters = {
      roles(data, value) {
        return data.filter(item => _.includes(item.roles, value))
      },
      search(data, value) {
        return data.filter(item => _.isEmpty(value) || _.includes(item.email.toLowerCase(), value.toLowerCase()))
      }
    };

    this.unsubscribers = [];

    this.unsubscribers.push($ngRedux.connect(this.mapStateToThis, UsersActions)(this));

    this.unsubscribers.push($ngRedux.subscribe(() => {
      if(!this.users || !this.gameDevelopers) { return; }
      let gameDevelopersById = _.keyBy(this.gameDevelopers, 'id');
      this.users.forEach((user) => {
        if (_.isArray(user.game_developer_ids)) {
          if (!_.isEmpty(user.game_developer_ids)) {
            user.gameDeveloper = gameDevelopersById[user.game_developer_ids[0]];
          }
        }
        else if(user.game_developer_ids !== null) {
          user.gameDeveloper = gameDevelopersById[user.game_developer_ids];
        }
      });
      this.resourcesTable.loadData(this.users);
    }));

    $scope.$on('$destroy', () => { _.forEach(this.unsubscribers, (unsubscribe) => unsubscribe() )});

    this.getResources();
  }

  mapStateToThis(state) {
    return {
      users: state.usersReducer.users,
      gameDevelopers: state.gameDevelopersReducer.gameDevelopers
    };
  }

  setActiveRoleBasedOnUserSearch() {
    this.filterTableBySearch();
    const foundUser = _.find(this.users, u => u.email.toLowerCase() === this.userNameFilterValue.toLowerCase());
    if (foundUser !== undefined) {
      this.activeRole = foundUser.role;
    }
  }

  getResources() {
    this.$q.all([
      this.$ngRedux.dispatch(GameDevelopersActions.fetchGameDevelopers(this.GameDevelopersResource)),
      this.$ngRedux.dispatch(UsersActions.fetchUsers(this.UsersResource))
    ]).then(() => { /*
        We could dispatch another action but atm it would bring only to an unnecessary new state.
        USERS_FETCH_SUCCESS and GAME_DEVELOPERS_FETCH_SUCCESS have been already dispatched. */
    });
  }


  remove(resource) {
    if (!this.$window.confirm(this.translateWith('confirmDelete', resource.email)))
      return false;
    // Only drop the row once the server confirms; a fire-and-forget delete hid backend
    // failures and made deleted users reappear on refresh.
    return resource.remove()
      .then(() => {
        this.resourcesTable.remove(resource);
        this.notify.removed('user', resource.email);
      })
      .catch(this.notify.apiError);
  }

  get activeRole() {
    return this.resourcesTable.filter()['roles'];
  }

  set activeRole(role) {
    this.resourcesTable.filter()['roles'] = role;
    this.resourcesTable.reload();
  }

  filterTableBySearch() {
    this.resourcesTable.filter()['search'] = this.userNameFilterValue;
    this.resourcesTable.reload();
  }
}

export function UsersIndexComponent() {
  return {
    template,
    controller: UsersIndexController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      title: '='
    },
    bindToController: true
  };
}

export default angular.module('app.components.admin.users.index', [
  ServicesModule.name,
  ResourcesModule.name,
  ngRedux
])
.directive('usersIndex', UsersIndexComponent);



/** WEBPACK FOOTER **
 ** ./src/components/admin/users/usersIndex.js
 **/